/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function */
import React from 'react';
import Keys from 'es6/core/keys';
import CourseTeaser from 'es6/components/apps/course-teaser';
import Localization from 'es6/services/localization';
import { NavButton, Navigation } from 'es6/components/apps/navigation';

export default React.createClass({
  displayName: 'CourseRecommendationScreen',

  propTypes: {
    aggregateMemory: React.PropTypes.object.isRequired,
    goal: React.PropTypes.object.isRequired,
    onMenu: React.PropTypes.func.isRequired,
    onStart: React.PropTypes.func.isRequired,
    onSkip: React.PropTypes.func.isRequired,
  },

  render() {
    const headerMessage = this.props.aggregateMemory && !this.props.aggregateMemory.startedAt ?
      Localization.t('course-recommendation.new-course-header') :
      Localization.t('course-recommendation.header');

    return (
      <div className="screen screen-course-recommendation">
        <div className="screen-content">
          <div className="message">
            <h1 className="header">{headerMessage}</h1>
          </div>

          <CourseTeaser enableRibbon enableStudyStats goal={this.props.goal} aggregateMemory={this.props.aggregateMemory} />
        </div>

        <Navigation>
          <NavButton align="left" onClick={this.props.onMenu}>{Localization.t('js_iknow.menu')}</NavButton>
          <NavButton align="right" onClick={this.props.onSkip}>{Localization.t('skip-recommended')}</NavButton>
          <NavButton align="right" keyCode={Keys.ENTER} focused onClick={this.props.onStart}>{Localization.t('start')}</NavButton>
        </Navigation>
      </div>
    );
  },
});
